const Domain = require('./domain.js');
const Backbone = require('backbone');

var Domains = Backbone.Collection.extend({

  url: '/api/domains',

  model: Domain

});


module.exports = Domains;
